import React, { useEffect, useContext } from 'react';
import { createBrazeClient } from '../braze';
export var BrazeContext = /*#__PURE__*/React.createContext({});
export var BrazeHooksProvider = function BrazeHooksProvider(_ref) {
  var brazeApiKey = _ref.brazeApiKey,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BrazeContext.Provider, {
    value: {
      braze: createBrazeClient(brazeApiKey)
    }
  }, children);
};
export var useBraze = function useBraze() {
  var _useContext = useContext(BrazeContext),
      braze = _useContext.braze;

  return {
    braze: braze
  };
};
export var useBrazeMessage = function useBrazeMessage() {
  var _useBraze = useBraze(),
      braze = _useBraze.braze;

  useEffect(function () {
    braze.showMessage();
  }, []);
  return braze;
};